import React from 'react';
import {Card, Space, Typography, Row, Col} from 'antd';
import {LinkOutlined} from '@ant-design/icons';
import { useTranslation } from '../hooks/useTranslation';
import { isEnglishSite } from '../config/site';

const { Title, Paragraph } = Typography;

const About: React.FC = () => {
  const { t, currentLanguage } = useTranslation();
  const isEn = currentLanguage === 'en';
  const isEnSite = isEnglishSite();
  const systemTitle = (window as any).systemTitle || t('system.title');
  
  // 计算运行年数
  const calculateRunningYears = () => {
    const createDate = new Date(2020, 0, 1); // 2020年1月1日
    const now = new Date();
    const diffTime = now.getTime() - createDate.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const years = diffDays / 365.25;
    
    if (years < 1) {
      return t('about.runningDays', { days: Math.floor(diffDays) });
    } else if (years < 2) {
      return t('about.runningYear');
    } else {
      return t('about.runningYears', { years: Math.floor(years) });
    }
  };

  const runningYears = calculateRunningYears();
  
  const linkStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 12px',
    borderRadius: '4px',
    transition: 'all 0.3s',
    textDecoration: 'none',
    color: '#1890ff',
  };

  const linkHoverStyle = {
    backgroundColor: '#f0f7ff',
    color: '#1890ff',
  };
  
  return (
    <div className="about-page" style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
      <Card>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          {/* 页面标题和介绍 */}
          <div style={{ textAlign: 'center', marginBottom: '32px' }}>
            <Title level={2} style={{ marginBottom: '16px' }}>{t('about.title')}</Title>
            <Paragraph style={{ fontSize: '16px', lineHeight: '1.8', color: '#666', maxWidth: '800px', margin: '0 auto' }}>
              {t('about.description', { years: runningYears })}
            </Paragraph>
          </div>

          {/* 使用网格布局优化内容区域 */}
          <Row gutter={[24, 24]}>
            {/* 相关链接 */}
            <Col xs={24} sm={24} md={12} lg={8}>
              <Card 
                title={<Title level={4} style={{ margin: 0 }}>{t('about.relatedLinks')}</Title>}
                style={{ height: '100%' }}
                bodyStyle={{ padding: '16px' }}
              >
                <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                  <a
                    href="https://blog.imgbed.cn/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={linkStyle}
                    onMouseEnter={(e) => {
                      Object.assign(e.currentTarget.style, linkHoverStyle);
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                  >
                    <LinkOutlined />
                    {t('about.blog')}
                  </a>
                  {!isEnSite && (
                    <a
                      href="https://blog.imgbed.cn/index.php/2025/08/30/%e5%9b%be%e5%ba%8a%e5%b0%8f%e9%95%87-%e6%9b%b4%e6%96%b0%e6%97%a5%e5%bf%97/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={linkStyle}
                      onMouseEnter={(e) => {
                        Object.assign(e.currentTarget.style, linkHoverStyle);
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'transparent';
                      }}
                    >
                      <LinkOutlined />
                      {t('about.changelog')}
                    </a>
                  )}
                  <a
                    href="https://blog.imgbed.cn/index.php/2025/08/29/%e5%9b%be%e5%ba%8a%e5%b0%8f%e9%95%87%e4%bd%bf%e7%94%a8%e5%bf%85%e8%af%bb/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={linkStyle}
                    onMouseEnter={(e) => {
                      Object.assign(e.currentTarget.style, linkHoverStyle);
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                  >
                    <LinkOutlined />
                    {t('about.usageGuide')}
                  </a>
                  <a
                    href="https://blog.imgbed.cn/index.php/2025/08/30/%e5%9b%be%e5%ba%8a%e5%b0%8f%e9%95%87-api-%e6%96%87%e6%a1%a3/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={linkStyle}
                    onMouseEnter={(e) => {
                      Object.assign(e.currentTarget.style, linkHoverStyle);
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                  >
                    <LinkOutlined />
                    {t('about.apiDocs')}
                  </a>
                </Space>
              </Card>
            </Col>

            {/* 购买链接 */}
            <Col xs={24} sm={24} md={12} lg={8}>
              <Card 
                title={<Title level={4} style={{ margin: 0 }}>{t('about.purchaseLinks')}</Title>}
                style={{ height: '100%' }}
                bodyStyle={{ padding: '16px' }}
              >
                <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                  <a
                    href="https://c.fakamiao.top/shopDetail/Wte5t6"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={linkStyle}
                    onMouseEnter={(e) => {
                      Object.assign(e.currentTarget.style, linkHoverStyle);
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                  >
                    <LinkOutlined />
                    {t('about.purchaseLink')}
                  </a>
                  <a
                    href="https://www.goofish.com/personal?userId=902384874"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={linkStyle}
                    onMouseEnter={(e) => {
                      Object.assign(e.currentTarget.style, linkHoverStyle);
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                  >
                    <LinkOutlined />
                    {t('about.xianyuStore')}
                  </a>
                </Space>
              </Card>
            </Col>

            {/* 联系方式 */}
            <Col xs={24} sm={24} md={24} lg={8}>
              <Card 
                title={<Title level={4} style={{ margin: 0 }}>{t('about.contactInfo')}</Title>}
                style={{ height: '100%' }}
                bodyStyle={{ padding: '16px' }}
              >
                <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                  {!isEn && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '4px 0' }}>
                      <span style={{ minWidth: '80px', color: '#666' }}>{t('about.wechat')}</span>
                      <span style={{ fontWeight: 500 }}>18215600321</span>
                    </div>
                  )}
                  {!isEn && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '4px 0' }}>
                      <span style={{ minWidth: '80px', color: '#666' }}>{t('about.qqGroup')}</span>
                      <span style={{ fontWeight: 500 }}>690748896</span>
                    </div>
                  )}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '4px 0' }}>
                    <span style={{ minWidth: '80px', color: '#666' }}>{t('about.email')}</span>
                    <a
                      href="mailto:fudongdong@fudongdong.com"
                      style={{ color: '#1890ff', textDecoration: 'none' }}
                    >
                      fudongdong@fudongdong.com
                    </a>
                  </div>
                </Space>
              </Card>
            </Col>
          </Row>

          {/* 二维码区域 */}
          <Row gutter={[24, 24]} style={{ marginTop: '8px' }}>
            {!isEn && (
              <Col xs={24} sm={12} md={12} lg={12}>
                <Card 
                  title={<Title level={4} style={{ margin: 0 }}>{t('about.wechatOfficial')}</Title>}
                  bodyStyle={{ padding: '16px', textAlign: 'center' }}
                >
                  <img
                    src="https://z.wiki/autoupload/20231209/2Vsb.1164X1122-IMG_1279.JPG"
                    alt={t('about.qrCodeAlt')}
                    style={{ maxWidth: '200px', width: '100%', height: 'auto', borderRadius: '8px' }}
                  />
                </Card>
              </Col>
            )}
            <Col xs={24} sm={12} md={12} lg={12}>
              <Card 
                title={<Title level={4} style={{ margin: 0 }}>{t('about.telegram')}</Title>}
                bodyStyle={{ padding: '16px', textAlign: 'center' }}
              >
                <img
                  src="https://tc-new.z.wiki/autoupload/fdd/20250812/iR01/862X950/image.png"
                  alt={t('about.telegramQrAlt')}
                  style={{ maxWidth: '200px', width: '100%', height: 'auto', borderRadius: '8px' }}
                />
              </Card>
            </Col>
          </Row>
        </Space>
      </Card>
    </div>
  );
};

export default About;
